import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight, ChevronDown } from 'lucide-react';
export function BlogPage() {
  return <div className="min-h-screen bg-white" data-id="element-592">
      {/* Header */}
      <Header variant="solid" data-id="element-593" />

      {/* Blog Archive Section */}
      <section className="bg-neutral-100 py-20 px-8 mt-20" data-id="element-594">
        <div className="max-w-7xl mx-auto" data-id="element-595">
          {/* Page Title */}
          <div className="mb-12" data-id="element-596">
            <h1 className="font-heading text-4xl lg:text-5xl text-neutral-900 leading-tight mb-4" data-id="element-597">
              News & Events
            </h1>
            <div className="w-full h-0.5 bg-brand-pink" data-id="element-598"></div>
          </div>

          {/* Filters */}
          <div className="flex gap-4 mb-12" data-id="element-599">
            <div className="relative" data-id="element-600">
              <select className="inline-flex items-center gap-2 px-6 py-3 border border-neutral-300 hover:bg-neutral-50 hover:border-brand-pink transition-colors rounded-none text-neutral-900 font-medium appearance-none pr-10 bg-white cursor-pointer" data-id="element-601">
                <option value="" data-id="element-602">All Categories</option>
                <option value="events" data-id="element-603">Events</option>
                <option value="news" data-id="element-604">News & Announcements</option>
                <option value="member-exclusives" data-id="element-605">Member Exclusives</option>
                <option value="vintage-updates" data-id="element-606">Vintage Updates</option>
                <option value="wine-education" data-id="element-607">Wine Education</option>
                <option value="restaurant" data-id="element-608">Restaurant & Dining</option>
                <option value="weddings" data-id="element-609">Weddings</option>
                <option value="cellar-door" data-id="element-610">Cellar Door Experiences</option>
              </select>
              <ChevronDown size={16} className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-neutral-900" data-id="element-611" />
            </div>
          </div>

          {/* Blog Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-612">
            {/* Blog Post 1 */}
            <article className="bg-white overflow-hidden flex flex-col" data-id="element-613">
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-300" data-id="element-614">
                <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Gelato-tasting-Peterson-House.jpg" alt="Peterson House Bubbleologist Experience" className="w-full h-full object-cover" data-id="element-615" />
              </div>
              <div className="p-8 flex flex-col flex-1" data-id="element-616">
                <h2 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-617">
                  Peterson House Bubbleologist Experience
                </h2>
                <p className="text-neutral-600 text-sm leading-relaxed mb-6 flex-1" data-id="element-618">
                  Dive into the world of sparkling wine with our exclusive
                  Bubbleologist Experience. Learn the art of tasting, discover
                  the nuances of different sparkling varieties, and become an
                  expert in all things bubbly. Perfect for wine enthusiasts and
                  those looking to deepen their appreciation of Peterson House's
                  finest offerings.
                </p>
                <a href="/blog/bubbleologist-experience" className="inline-flex items-center gap-2 px-6 py-3 border border-neutral-300 text-neutral-900 hover:border-brand-pink hover:text-brand-pink transition-colors rounded-none font-medium group" data-id="element-619">
                  Read More
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-620" />
                </a>
              </div>
            </article>

            {/* Blog Post 2 */}
            <article className="bg-white overflow-hidden flex flex-col" data-id="element-621">
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-300" data-id="element-622">
                <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/landscape-cd-entry-with-wine-wall.jpg" alt="Pink Blush Rosé" className="w-full h-full object-cover" data-id="element-623" />
              </div>
              <div className="p-8 flex flex-col flex-1" data-id="element-624">
                <h2 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-625">
                  I have three words for you. Pink Blush Rosé. Delve into the
                  life of our most popular wine here at Peterson House!
                </h2>
                <p className="text-neutral-600 text-sm leading-relaxed mb-6 flex-1" data-id="element-626">
                  Our signature Pink Blush Rosé has captured hearts across the
                  Hunter Valley and beyond. Discover the story behind our most
                  beloved sparkling wine, from vine to glass. Learn what makes
                  this wine so special and why it's become a Peterson House
                  icon.
                </p>
                <a href="/blog/pink-blush-rose" className="inline-flex items-center gap-2 px-6 py-3 border border-neutral-300 text-neutral-900 hover:border-brand-pink hover:text-brand-pink transition-colors rounded-none font-medium group" data-id="element-627">
                  Read More
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-628" />
                </a>
              </div>
            </article>

            {/* Blog Post 3 */}
            <article className="bg-white overflow-hidden flex flex-col" data-id="element-629">
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-300" data-id="element-630">
                <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Peterson-House-Restaurant-Image.jpg" alt="Corn Fritters" className="w-full h-full object-cover" data-id="element-631" />
              </div>
              <div className="p-8 flex flex-col flex-1" data-id="element-632">
                <h2 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-633">
                  Craving our famous Corn Fritters?
                </h2>
                <p className="text-neutral-600 text-sm leading-relaxed mb-6 flex-1" data-id="element-634">
                  Our award-winning corn fritters have become legendary in the
                  Hunter Valley. Crispy on the outside, fluffy on the inside,
                  and perfectly paired with our sparkling wines. Discover the
                  secret behind this restaurant favorite and why guests keep
                  coming back for more.
                </p>
                <a href="/blog/corn-fritters" className="inline-flex items-center gap-2 px-6 py-3 border border-neutral-300 text-neutral-900 hover:border-brand-pink hover:text-brand-pink transition-colors rounded-none font-medium group" data-id="element-635">
                  Read More
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-636" />
                </a>
              </div>
            </article>

            {/* Blog Post 4 */}
            <article className="bg-white overflow-hidden flex flex-col" data-id="element-637">
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-300" data-id="element-638">
                <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Peterdsound-House-cellar-Door-Tasting.jpg" alt="Universal Chapel" className="w-full h-full object-cover" data-id="element-639" />
              </div>
              <div className="p-8 flex flex-col flex-1" data-id="element-640">
                <h2 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-641">
                  Timeless Love Awaits: A Universal Chapel for Every Couple!
                </h2>
                <p className="text-neutral-600 text-sm leading-relaxed mb-6 flex-1" data-id="element-642">
                  Celebrate your love in our beautiful universal chapel,
                  welcoming couples of all backgrounds and beliefs. With
                  stunning vineyard views and intimate spaces, Peterson House
                  provides the perfect setting for your special day. Discover
                  why couples choose our romantic venue for their wedding
                  celebrations.
                </p>
                <a href="/blog/universal-chapel" className="inline-flex items-center gap-2 px-6 py-3 border border-neutral-300 text-neutral-900 hover:border-brand-pink hover:text-brand-pink transition-colors rounded-none font-medium group" data-id="element-643">
                  Read More
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-644" />
                </a>
              </div>
            </article>

            {/* Blog Post 5 */}
            <article className="bg-white overflow-hidden flex flex-col" data-id="element-645">
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-300" data-id="element-646">
                <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/12/3-cheeseplate-1.12.25.jpg" alt="Members Harvest Experience" className="w-full h-full object-cover" data-id="element-647" />
              </div>
              <div className="p-8 flex flex-col flex-1" data-id="element-648">
                <h2 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-649">
                  Peterson House's First Members Harvest Experience
                </h2>
                <p className="text-neutral-600 text-sm leading-relaxed mb-6 flex-1" data-id="element-650">
                  Join us for an exclusive behind-the-scenes look at harvest
                  season. Our wine club members get hands-on experience picking
                  grapes, learning about winemaking, and tasting wines straight
                  from the barrel. Discover what makes this annual event so
                  special for our Peterson House family.
                </p>
                <a href="/blog/members-harvest" className="inline-flex items-center gap-2 px-6 py-3 border border-neutral-300 text-neutral-900 hover:border-brand-pink hover:text-brand-pink transition-colors rounded-none font-medium group" data-id="element-651">
                  Read More
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-652" />
                </a>
              </div>
            </article>

            {/* Blog Post 6 */}
            <article className="bg-white overflow-hidden flex flex-col" data-id="element-653">
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-300" data-id="element-654">
                <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Glass-1-Right-cellar-door.jpg" alt="Gelato and Sparkling Wines" className="w-full h-full object-cover" data-id="element-655" />
              </div>
              <div className="p-8 flex flex-col flex-1" data-id="element-656">
                <h2 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-657">
                  When Gelato Met Sparkling Wines!
                </h2>
                <p className="text-neutral-600 text-sm leading-relaxed mb-6 flex-1" data-id="element-658">
                  Experience the magic of our unique gelato and sparkling wine
                  pairing. A sensory adventure like no other in the Hunter
                  Valley, combining locally sourced artisan gelato with our
                  finest bubbles. Discover the surprising flavor combinations
                  that make this experience unforgettable.
                </p>
                <a href="/blog/gelato-sparkling" className="inline-flex items-center gap-2 px-6 py-3 border border-neutral-300 text-neutral-900 hover:border-brand-pink hover:text-brand-pink transition-colors rounded-none font-medium group" data-id="element-659">
                  Read More
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-660" />
                </a>
              </div>
            </article>

            {/* Blog Post 7 */}
            <article className="bg-white overflow-hidden flex flex-col" data-id="element-661">
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-300" data-id="element-662">
                <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Gelato-tasting-Peterson-House.jpg" alt="30 Years Anniversary" className="w-full h-full object-cover" data-id="element-663" />
              </div>
              <div className="p-8 flex flex-col flex-1" data-id="element-664">
                <h2 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-665">
                  Cheers to 30 Sparkling Years at Peterson House
                </h2>
                <p className="text-neutral-600 text-sm leading-relaxed mb-6 flex-1" data-id="element-666">
                  Celebrating three decades of excellence in sparkling wine
                  production. From humble beginnings to becoming a Hunter Valley
                  icon, join us as we reflect on 30 years of passion,
                  dedication, and unforgettable bubbles. Discover the milestones
                  that shaped Peterson House into what it is today.
                </p>
                <a href="/blog/thirty-years" className="inline-flex items-center gap-2 px-6 py-3 border border-neutral-300 text-neutral-900 hover:border-brand-pink hover:text-brand-pink transition-colors rounded-none font-medium group" data-id="element-667">
                  Read More
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-668" />
                </a>
              </div>
            </article>

            {/* Blog Post 8 */}
            <article className="bg-white overflow-hidden flex flex-col" data-id="element-669">
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-300" data-id="element-670">
                <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/landscape-cd-entry-with-wine-wall.jpg" alt="Wine Club Benefits" className="w-full h-full object-cover" data-id="element-671" />
              </div>
              <div className="p-8 flex flex-col flex-1" data-id="element-672">
                <h2 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-673">
                  Woo-Hoo we love our Peterson House Wine Club!
                </h2>
                <p className="text-neutral-600 text-sm leading-relaxed mb-6 flex-1" data-id="element-674">
                  Discover the incredible benefits of joining our Wine Club.
                  From exclusive events across the East Coast to unique Hunter
                  Valley experiences, member discounts, and two club options to
                  suit your taste. Learn why our members love being part of the
                  Peterson House family.
                </p>
                <a href="/blog/wine-club-benefits" className="inline-flex items-center gap-2 px-6 py-3 border border-neutral-300 text-neutral-900 hover:border-brand-pink hover:text-brand-pink transition-colors rounded-none font-medium group" data-id="element-675">
                  Read More
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-676" />
                </a>
              </div>
            </article>

            {/* Blog Post 9 */}
            <article className="bg-white overflow-hidden flex flex-col" data-id="element-677">
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-300" data-id="element-678">
                <img src="https://crudemomultisite.kinsta.cloud/wine-theme-1/wp-content/uploads/sites/2/2025/11/Peterson-House-Restaurant-Image.jpg" alt="Traditional Method Sparkling Wines" className="w-full h-full object-cover" data-id="element-679" />
              </div>
              <div className="p-8 flex flex-col flex-1" data-id="element-680">
                <h2 className="font-heading text-2xl text-neutral-900 mb-4" data-id="element-681">
                  The process of perfection: How we make our Traditional Method
                  Sparkling Wines
                </h2>
                <p className="text-neutral-600 text-sm leading-relaxed mb-6 flex-1" data-id="element-682">
                  Discover the art of sparkling wine production in our exclusive
                  masterclass. Learn about the traditional méthode and taste
                  through our premium range of sparkling wines. Perfect for wine
                  enthusiasts and those looking to deepen their knowledge of the
                  Hunter Valley's finest bubbles.
                </p>
                <button className="inline-flex items-center gap-2 px-6 py-3 border border-neutral-300 text-neutral-900 hover:border-brand-pink hover:text-brand-pink transition-colors rounded-none font-medium group" data-id="element-683">
                  Read More
                  <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform duration-200" data-id="element-684" />
                </button>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer data-id="element-685" />
    </div>;
}